<template>
  <!--
      	作者：zhuchangtao
      	时间：2021-07-01
      	描述：打卡抽奖奖项活动-抽奖奖项活动列表
      -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">

        <el-form-item label="奖项活动标题">
          <el-input v-model="formInline.title" placeholder="请输入奖项活动标题"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- <div class="common-form">秒杀抽奖奖项活动列表</div> -->
    <div class="common-level-rail" v-if="formInline.sweepstakes_id">
      <el-button size="small" icon="el-icon-plus" type="primary" v-auth="'/plus/sweepstakes/sweepstakesawards/add'" @click="addClick">添加抽奖奖项活动</el-button>
    </div>
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="awards_id" label="抽奖奖项活动ID" ></el-table-column>
            <el-table-column prop="sweepstakes.sweepstakes_name" label="抽奖奖项活动标题" ></el-table-column>

            <el-table-column prop="title" label="抽奖奖项文案" ></el-table-column>
             <el-table-column prop="is_image" label="是否有图片" >
              <template slot-scope="scope">
                <div v-if="scope.row.is_image">是</div>
                <div v-else>否</div>
              </template>
             </el-table-column>
            <el-table-column prop="is_point" label="是否获取积分" >
              <template slot-scope="scope">
                <div v-if="scope.row.is_point">是</div>
                <div v-else>否</div>
              </template>
            </el-table-column>
            <el-table-column prop="point" label="获取积分" ></el-table-column>
            <el-table-column prop="is_product" label="是否获取礼品" >
              <template slot-scope="scope">
                <div v-if="scope.row.is_product">是</div>
                <div v-else>否</div>
              </template>
            </el-table-column>
            <el-table-column prop="product.product_name" label="获取礼品名称" ></el-table-column>
            <el-table-column prop="product_num" label="礼品数量"></el-table-column>
            <el-table-column label="码详情" width="70">
              <template slot-scope="scope">
                <el-button @click="codeListClick(scope.row)" type="text" v-auth="'/plus/sweepstakes/sweepstakesawards/code_list'" size="small">查看</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间"  width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="200">
              <template slot-scope="scope">

                <el-button @click="addCodeClick(scope.row)" type="text" v-auth="'/plus/sweepstakes/sweepstakesawards/add_code'" size="small">批量生码</el-button>

                <el-button @click="exportClick(scope.row)" type="text" v-auth="'/plus/sweepstakes/sweepstakesawards/export'" size="small">导出</el-button>

                <el-button @click="editClick(scope.row)" type="text" v-auth="'/plus/sweepstakes/sweepstakesawards/edit'" size="small">编辑</el-button>

                <el-button @click="deleteClick(scope.row)" type="text" v-auth="'/plus/sweepstakes/sweepstakesawards/delete'" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
           :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
    <CodeList v-if="code_list_open" :open_edit="code_list_open" @closeDialog="closeDialogFunc($event)" :awards_id="awards_id"></CodeList>
    <AddCode v-if="add_code_open" :open_edit="add_code_open" @closeDialog="closeDialogFunc($event)" :awards_id="awards_id" :sweepstakes_id="formInline.sweepstakes_id"></AddCode>
  </div>
</template>

<script>
  import SweepstakesApi from '@/api/sweepstakes.js';
  import CodeList from './part/CodeList';
  import AddCode from './part/AddCode';
  import qs from 'qs';
  export default {
    components: {
      AddCode,
      CodeList
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        form: {},
        /*批量生码*/
        add_code_open: false,
        /*详情*/
        code_list_open: false,
        /*当前编辑的对象*/
        awards_id: 0,
        formInline: {
          title:'',
          sweepstakes_id:''
        },
        status: ['未生效', '生效'],
          file:{},
      };
    },
    created() {
      this.formInline.sweepstakes_id = this.$route.query.sweepstakes_id;
      /*获取列表*/
      this.getTableList();

    },
    methods: {

      addCodeClick(row) {
        this.add_code_open = true
        this.awards_id = row.awards_id
      },

      codeListClick(row) {
        this.code_list_open = true
        this.awards_id = row.awards_id
      },

      exportClick(row) {
        let param = {awards_id:row.awards_id,sweepstakes_id:this.formInline.sweepstakes_id}
        let baseUrl = window.location.protocol + '//' + window.location.host;
                window.location.href = baseUrl + '/index.php/shop/plus.sweepstakes.sweepstakesAwards/export?'+qs.stringify(param);
      },

      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        SweepstakesApi.sweepstakesAwardsList(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total
          })
          .catch(error => {
              self.loading = false;
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },
      awardsClick(row){
        let sweepstakes_id = row.sweepstakes_id;
        this.$router.push({
          path: '/plus/sweepstakes/sweepstakesawards/index',
          query: {
            sweepstakes_id: sweepstakes_id
          }
        })
      },
      /*打开添加*/
      addClick() {
        let sweepstakes_id = this.formInline.sweepstakes_id;
        this.$router.push({
          path: '/plus/sweepstakes/sweepstakesawards/add',
          query: {
            sweepstakes_id: sweepstakes_id
          }
        })
      },

      /*打开编辑*/
      editClick(row) {
        let awards_id = row.awards_id;
        this.$router.push({
          path: '/plus/sweepstakes/sweepstakesawards/edit',
          query: {
            awards_id: awards_id
          }
        })
      },

      /*删除*/
      deleteClick(row) {

        let self = this;
        self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          SweepstakesApi.delSweepstakesAwards({
              awards_id: row.awards_id
            }, true)
            .then(data => {
              if (data.code == 1) {
                self.$message({
                  message: '恭喜你，抽奖奖项活动删除成功',
                  type: 'success'
                });
                //刷新页面
                self.getTableList();
              } else {
                self.$message.error('错了哦，这是一条错误消息');
              }
            })
            .catch(error => {

            });

        }).catch(() => {});
      },
      /*关闭弹窗*/
      closeDialogFunc(e) {
        this.code_list_open = e.openDialog;
        this.add_code_open = e.openDialog;
        this.awards_id = 0;
      },

    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/sweepstakes/sweepstakesawards/index.vue